import { render, staticRenderFns } from "./CareerError.vue?vue&type=template&id=20484ef0&scoped=true&"
import script from "./CareerError.vue?vue&type=script&lang=js&"
export * from "./CareerError.vue?vue&type=script&lang=js&"
import style0 from "./CareerError.vue?vue&type=style&index=0&id=20484ef0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20484ef0",
  null
  
)

export default component.exports